
<template>
  <div :bannerOverseasChineseMerchantList='bannerOverseasChineseMerchantList' class="bannerOverseasChineseMerchantList">
    <el-row :gutter="20">
      <el-col :span="4" class="MobList" style="margin-bottom:15px;" v-for="(item,index) in bannerOverseasChineseMerchantList" :key="index">
        <div class="bannerOverseasChineseMerchantListCol" style="cursor:pointer;background: #fff;" @click="Enter(item)">
           <div class="bannerHotIndustryListBox">
              <div class="bannerOverseasChineseMerchantListImg">
                  <img v-lazy="$funcs.compressImage(item.coverIcon)" @error="defImg()" class="lazy-img-fadein"/>
              </div>
              <p class="bannerOverseasChineseMerchantName ellipsis-2">{{item.title}}</p>
            </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    bannerOverseasChineseMerchantList: {
      type: [Object, String, Array],
      default: () => ''
    }
  },
  data() {
    return {
        tagNameList:[],
        iconUrl:''
    }
  },
  computed: {
    ...mapGetters(['language', 'info', 'isLogin', 'subjectType']),
  },
  created(){

  },
  mounted() {},
  methods: {
    defImg(){
      let img = event.srcElement;
      img.src = this.defImage('product');
      img.onerror = null; //防止闪图
    },
    Enter(param){
      console.log(param)
      let status = this.$config.settings.onlayReg2
      if (!status) {
        this.commonStatistics('001032000', param)
      }
      window.PC.$RangersEvent("home_hot_industry_click", {
        carouselmap_id: param.id
      }, () => {
        /**
         * EXTERNAL       外部链接
         * ACTOR_DETAILS  展商详情
         * TAG_EXHIBITOR  展商列表
         */
        if (param.urlType == 'EXTERNAL') {
          if (param.url === '') {
            return
          } else {
            window.open(param.url, '_blank')
          }
        } else {
          if (status) {
            this.goLogin()
            return 
          }
          if (param.urlType=="ACTOR_DETAILS"){
            this.pageDetail(param, 'actor')
          }else if (param.urlType=="PRODUCT_DETAILS"){
            param.productId = param.url
            this.pageDetail(param, 'product')
          } else if (param.urlType == "TAG_EXHIBITOR"){
            sessionStorage.setItem('findListActor',param.url)
            this.$router.push({ path: '/find/actor' })
          } else if (param.urlType == "TAG_PRODUCT"){
            this.$router.push({ path: '/find/product', query: {type: param.url} })
          } else {
            console.log('暂时没有匹配操作')
          }

        }
      })
    }
    
  }
}
</script>

<style lang="stylus" scoped>

.bannerOverseasChineseMerchantName{
  padding: 0 5px;
  line-height: 22px;
  height: 45px;
  overflow: hidden;
  color: $color-main;
  text-align:center;
  font-weight: bold;
}
.bannerOverseasChineseMerchantListCol{
  &:hover {
    box-shadow: 0 6px 20px 5px $box-shadow1, 0 16px 24px 2px $box-shadow2;
    transition: 0.3s all;
    img {
      transform: scale(1.2);
    }
  }
}
.bannerOverseasChineseMerchantListImg{
  // height 206px
  margin-bottom 5px
  overflow hidden
  background:#ffffff;
  img{
      transition: all .3s;
      width: 100%
      height 100%
      object-fit: contain;
  }
}
  .tagList{
    height 28px
    width 170px;
    overflow hidden
  }
</style>
